const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { itemsDataSetQueryOptions } from '@/lib/queries/common/useGetItemsDataSetQuery';
import { getScenariosQueryOptions } from '@/lib/queries/loop-planner/useGetScenarios';
import { getLastVisitedScenarioId } from '@/lib/utils/planner/lastVisitedScenario';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/')({
  loader: async ({
    params: {
      loopId,
      org
    },
    context: {
      queryClient
    }
  }) => {
    const [scenarios] = await Promise.all([queryClient.ensureQueryData(getScenariosQueryOptions({
      loopId
    })), queryClient.ensureQueryData(itemsDataSetQueryOptions({
      filter: {
        loopId: {
          value: loopId,
          operator: 'eq'
        }
      }
    }))]);
    const lastScenarioId = getLastVisitedScenarioId(loopId);
    const lastMatch = lastScenarioId !== null ? scenarios.find(s => s.scenario.id === lastScenarioId) : undefined;
    const target = lastMatch ?? scenarios[0];
    if (target) {
      throw redirect({
        to: '/org/$org/loop/$loopId/planner/scenario/$scenarioId',
        params: {
          org,
          loopId,
          scenarioId: target.scenario.id
        }
      });
    }
    return null;
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});